/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  IntakeFormTemplateAdminApiOutContract
} from '../pwrdbyQuickMDAdminsApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Creates a new intake form template using the data provided in the request body.
 */
export const postIntakeforms = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<IntakeFormTemplateAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/intakeforms`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntakeformsMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntakeforms>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntakeforms>>, TError,void, TContext> => {

const mutationKey = ['postIntakeforms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntakeforms>>, void> = () => {
          

          return  postIntakeforms(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntakeformsMutationResult = NonNullable<Awaited<ReturnType<typeof postIntakeforms>>>
    
    export type PostIntakeformsMutationError = void | ErrorApiOutContract

    /**
 * @summary Creates a new intake form template using the data provided in the request body.
 */
export const usePostIntakeforms = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntakeforms>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntakeforms>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostIntakeformsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Retrieves a collection of intake form templates.
 */
export const getIntakeforms = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<IntakeFormTemplateAdminApiOutContract[]>(
      {url: `https://admins-api.api.quick.md/api/v1/intakeforms`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntakeformsInfiniteQueryKey = () => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/intakeforms`
    ] as const;
    }

export const getGetIntakeformsQueryKey = () => {
    return [
    `https://admins-api.api.quick.md/api/v1/intakeforms`
    ] as const;
    }

    
export const getGetIntakeformsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getIntakeforms>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntakeformsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntakeforms>>> = ({ signal }) => getIntakeforms(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntakeformsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getIntakeforms>>>
export type GetIntakeformsInfiniteQueryError = void | ErrorApiOutContract


export function useGetIntakeformsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeforms>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntakeforms>>,
          TError,
          Awaited<ReturnType<typeof getIntakeforms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeformsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeforms>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntakeforms>>,
          TError,
          Awaited<ReturnType<typeof getIntakeforms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeformsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeforms>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a collection of intake form templates.
 */

export function useGetIntakeformsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeforms>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntakeformsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a collection of intake form templates.
 */
export const prefetchGetIntakeformsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getIntakeforms>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetIntakeformsInfiniteQueryOptions(options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetIntakeformsQueryOptions = <TData = Awaited<ReturnType<typeof getIntakeforms>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntakeformsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntakeforms>>> = ({ signal }) => getIntakeforms(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntakeformsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntakeforms>>>
export type GetIntakeformsQueryError = void | ErrorApiOutContract


export function useGetIntakeforms<TData = Awaited<ReturnType<typeof getIntakeforms>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntakeforms>>,
          TError,
          Awaited<ReturnType<typeof getIntakeforms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeforms<TData = Awaited<ReturnType<typeof getIntakeforms>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntakeforms>>,
          TError,
          Awaited<ReturnType<typeof getIntakeforms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeforms<TData = Awaited<ReturnType<typeof getIntakeforms>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a collection of intake form templates.
 */

export function useGetIntakeforms<TData = Awaited<ReturnType<typeof getIntakeforms>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntakeformsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a collection of intake form templates.
 */
export const prefetchGetIntakeformsQuery = async <TData = Awaited<ReturnType<typeof getIntakeforms>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetIntakeformsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetIntakeformsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getIntakeforms>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntakeformsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntakeforms>>> = ({ signal }) => getIntakeforms(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntakeformsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getIntakeforms>>>
export type GetIntakeformsSuspenseQueryError = void | ErrorApiOutContract


export function useGetIntakeformsSuspense<TData = Awaited<ReturnType<typeof getIntakeforms>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeformsSuspense<TData = Awaited<ReturnType<typeof getIntakeforms>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeformsSuspense<TData = Awaited<ReturnType<typeof getIntakeforms>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a collection of intake form templates.
 */

export function useGetIntakeformsSuspense<TData = Awaited<ReturnType<typeof getIntakeforms>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntakeformsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetIntakeformsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getIntakeforms>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntakeformsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntakeforms>>> = ({ signal }) => getIntakeforms(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntakeformsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getIntakeforms>>>
export type GetIntakeformsSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetIntakeformsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeforms>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeformsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeforms>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeformsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeforms>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a collection of intake form templates.
 */

export function useGetIntakeformsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeforms>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntakeformsSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Updates an existing intake form template using the provided template ID and the data in the request body.
 */
export const putIntakeformsIntakeFormTemplateId = (
    intakeFormTemplateId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<IntakeFormTemplateAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/intakeforms/${encodeURIComponent(String(intakeFormTemplateId))}`, method: 'PUT'
    },
      options);
    }
  


export const getPutIntakeformsIntakeFormTemplateIdMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntakeformsIntakeFormTemplateId>>, TError,{intakeFormTemplateId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putIntakeformsIntakeFormTemplateId>>, TError,{intakeFormTemplateId: string}, TContext> => {

const mutationKey = ['putIntakeformsIntakeFormTemplateId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putIntakeformsIntakeFormTemplateId>>, {intakeFormTemplateId: string}> = (props) => {
          const {intakeFormTemplateId} = props ?? {};

          return  putIntakeformsIntakeFormTemplateId(intakeFormTemplateId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutIntakeformsIntakeFormTemplateIdMutationResult = NonNullable<Awaited<ReturnType<typeof putIntakeformsIntakeFormTemplateId>>>
    
    export type PutIntakeformsIntakeFormTemplateIdMutationError = void | ErrorApiOutContract

    /**
 * @summary Updates an existing intake form template using the provided template ID and the data in the request body.
 */
export const usePutIntakeformsIntakeFormTemplateId = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntakeformsIntakeFormTemplateId>>, TError,{intakeFormTemplateId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putIntakeformsIntakeFormTemplateId>>,
        TError,
        {intakeFormTemplateId: string},
        TContext
      > => {

      const mutationOptions = getPutIntakeformsIntakeFormTemplateIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Retrieves a specific intake form template using the provided template ID.
 */
export const getIntakeformsIntakeFormTemplateId = (
    intakeFormTemplateId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<IntakeFormTemplateAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/intakeforms/${encodeURIComponent(String(intakeFormTemplateId))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntakeformsIntakeFormTemplateIdInfiniteQueryKey = (intakeFormTemplateId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/intakeforms/${intakeFormTemplateId}`
    ] as const;
    }

export const getGetIntakeformsIntakeFormTemplateIdQueryKey = (intakeFormTemplateId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/intakeforms/${intakeFormTemplateId}`
    ] as const;
    }

    
export const getGetIntakeformsIntakeFormTemplateIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>>, TError = void | ErrorApiOutContract>(intakeFormTemplateId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntakeformsIntakeFormTemplateIdInfiniteQueryKey(intakeFormTemplateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>> = ({ signal }) => getIntakeformsIntakeFormTemplateId(intakeFormTemplateId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(intakeFormTemplateId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntakeformsIntakeFormTemplateIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>>
export type GetIntakeformsIntakeFormTemplateIdInfiniteQueryError = void | ErrorApiOutContract


export function useGetIntakeformsIntakeFormTemplateIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>,
          TError,
          Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeformsIntakeFormTemplateIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>,
          TError,
          Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeformsIntakeFormTemplateIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific intake form template using the provided template ID.
 */

export function useGetIntakeformsIntakeFormTemplateIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntakeformsIntakeFormTemplateIdInfiniteQueryOptions(intakeFormTemplateId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a specific intake form template using the provided template ID.
 */
export const prefetchGetIntakeformsIntakeFormTemplateIdInfiniteQuery = async <TData = Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, intakeFormTemplateId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetIntakeformsIntakeFormTemplateIdInfiniteQueryOptions(intakeFormTemplateId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetIntakeformsIntakeFormTemplateIdQueryOptions = <TData = Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError = void | ErrorApiOutContract>(intakeFormTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntakeformsIntakeFormTemplateIdQueryKey(intakeFormTemplateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>> = ({ signal }) => getIntakeformsIntakeFormTemplateId(intakeFormTemplateId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(intakeFormTemplateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntakeformsIntakeFormTemplateIdQueryResult = NonNullable<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>>
export type GetIntakeformsIntakeFormTemplateIdQueryError = void | ErrorApiOutContract


export function useGetIntakeformsIntakeFormTemplateId<TData = Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>,
          TError,
          Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeformsIntakeFormTemplateId<TData = Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>,
          TError,
          Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeformsIntakeFormTemplateId<TData = Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific intake form template using the provided template ID.
 */

export function useGetIntakeformsIntakeFormTemplateId<TData = Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntakeformsIntakeFormTemplateIdQueryOptions(intakeFormTemplateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a specific intake form template using the provided template ID.
 */
export const prefetchGetIntakeformsIntakeFormTemplateIdQuery = async <TData = Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, intakeFormTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetIntakeformsIntakeFormTemplateIdQueryOptions(intakeFormTemplateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetIntakeformsIntakeFormTemplateIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError = void | ErrorApiOutContract>(intakeFormTemplateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntakeformsIntakeFormTemplateIdQueryKey(intakeFormTemplateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>> = ({ signal }) => getIntakeformsIntakeFormTemplateId(intakeFormTemplateId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntakeformsIntakeFormTemplateIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>>
export type GetIntakeformsIntakeFormTemplateIdSuspenseQueryError = void | ErrorApiOutContract


export function useGetIntakeformsIntakeFormTemplateIdSuspense<TData = Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeformsIntakeFormTemplateIdSuspense<TData = Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeformsIntakeFormTemplateIdSuspense<TData = Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific intake form template using the provided template ID.
 */

export function useGetIntakeformsIntakeFormTemplateIdSuspense<TData = Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntakeformsIntakeFormTemplateIdSuspenseQueryOptions(intakeFormTemplateId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetIntakeformsIntakeFormTemplateIdSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>>, TError = void | ErrorApiOutContract>(intakeFormTemplateId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntakeformsIntakeFormTemplateIdInfiniteQueryKey(intakeFormTemplateId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>> = ({ signal }) => getIntakeformsIntakeFormTemplateId(intakeFormTemplateId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntakeformsIntakeFormTemplateIdSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>>
export type GetIntakeformsIntakeFormTemplateIdSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetIntakeformsIntakeFormTemplateIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeformsIntakeFormTemplateIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntakeformsIntakeFormTemplateIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific intake form template using the provided template ID.
 */

export function useGetIntakeformsIntakeFormTemplateIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>>, TError = void | ErrorApiOutContract>(
 intakeFormTemplateId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getIntakeformsIntakeFormTemplateId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntakeformsIntakeFormTemplateIdSuspenseInfiniteQueryOptions(intakeFormTemplateId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




